import { render } from "./StockCards.vue?vue&type=template&id=21bcb326&scoped=true"
import script from "./StockCards.vue?vue&type=script&lang=js"
export * from "./StockCards.vue?vue&type=script&lang=js"

import "./StockCards.vue?vue&type=style&index=0&id=21bcb326&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bcb326"]])

export default __exports__